import { useMemo } from 'react';

const useEnvironment = () => {
  const getEnvironment = useMemo(() => {
    if (typeof window !== 'undefined') {
      const dev = process.env.NODE_ENV === 'development';
      const devUrl = window.location.hostname.includes('elo.health');
      const stagingUrl = window.location.hostname.includes('staging');

      // Conditions based on the environment and URL
      if (dev) {
        return true; // Always return true in development environment
      } else {
        // In production, return true only if hostname does not include 'elo.health' and 'staging'
        return !devUrl && !stagingUrl;
      }
    }
    return false; // Return false by default if window is undefined
  }, []); // Dependencies for useMemo

  return { useDev: getEnvironment };
};

export default useEnvironment;
